var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcEnrichment = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66px",
    height: "86px",
    viewBox: "0 0 66 86",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.2.-Import",
    transform: "translate(-337.000000, -314.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(35.000000, 169.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask-2-Copy-10",
    transform: "translate(175.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-page",
    transform: "translate(128.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62,84 L2,84 C0.8954305,84 1.3527075e-16,83.1045695 0,82 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L44,0 L44,0 L64,20 L64,82 C64,83.1045695 63.1045695,84 62,84 Z",
    id: "Path",
    stroke: "#4F5964",
    strokeWidth: 2,
    fill: "#EFF0F2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "61 22 42 22 42 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,12 L34,12 L34,22 L12,22 L12,12 Z M52,46 L20,46 L20,42 L52,42 L52,46 Z M52,34 L20,34 L20,38 L52,38 L52,34 Z M52,58 L20,58 L20,62 L52,62 L52,58 Z M52,66 L20,66 L20,70 L52,70 L52,66 Z M52,50 L20,50 L20,54 L52,54 L52,50 Z M12,38 L16,38 L16,34 L12,34 L12,38 Z M12,46 L16,46 L16,42 L12,42 L12,46 Z M12,70 L16,70 L16,66 L12,66 L12,70 Z M12,54 L16,54 L16,50 L12,50 L12,54 Z M12,62 L16,62 L16,58 L12,58 L12,62 Z",
    id: "Shape",
    fill: "#BEC4CA"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcEnrichment, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-enrichment.4ca93ee7.svg";
export { ForwardRef as ReactComponent };